

<template>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">

  </head>

  <link rel="shortcut icon" type="image/jpg" href="../img/logo.png" />

  <div class=" mx-auto sm:w-full">



    <!-- <div style="width: 1922.94px; height: 1342.23px; position: absolute">
  <div style="width: 871.78px; height: 761.72px; left: 1092.12px; top: 62.07px; position: absolute; transform: rotate(17.63deg); transform-origin: 0 0; background: linear-gradient(201deg, #A0C8F8 0%, #C9F9DC 100%)"></div>
  <div style="width: 967.45px; height: 834.15px; left: 655.08px; top: 0px; position: absolute; transform: rotate(132.62deg); transform-origin: 0 0; background: linear-gradient(107deg, #57D9E3 0%, #207BC0 100%)"></div>
</div> -->
    <div class="relative items-center px-4 pt-[200px] sm:px-6 flex lg:justify-between lg:px-8 flex-col">

      <div class="font-family: Georgia text-center text-gray-300 text-sm md:text-4xl font-extrabold">Cloudamai
      </div>

      <!-- <div class=" font-family: Georgia font-semibold text-center text-gray-600 text-5xl dark:text-white">Text-To-Video</div> -->


      <!-- <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
        <div class="inline-flex rounded-md shadow">
          <router-link
            to="/"
            class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out hover:bg-indigo-500 focus:outline-none"
          >Back Home</router-link>
        </div>
        <ButtonRepo />
      </div> -->

    </div>





    <div class="mx-auto max-w-screen-lg pl-5 pr-5 relative py-12 lg:flex lg:items-center text-justify lg:py-16 ">

      <p class="font-family: Georgia text-sm md:text-lg text-gray-200">
        We are leveraging Generative AI to develop a solution that empowers users to effortlessly transform text into
        captivating short video content, with no need for editing. You can keep it as simple or make it as complex as you
        like. Creating shorts through prompts eliminates the need for video editing, shifting the focus solely to
        creativity.

      </p>


    </div>



    <i class="fa-solid fa-gear fa-spin-pulse"></i>

    <!-- responsible for middle div -->
    <div class="mx-auto max-w-screen-lg">
      <div class="">


        <div class="relative">
          <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor"
              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <button 
            class="text-white h-[90%] p-3 m-1 absolute right-0 bg-gray-700  font-medium rounded-lg text-lg md:text-xl bg-gradient-to-b from-[#3FADBC] to-[#1c565d] font-family: Georgia">Generate</button>

          <div type="search"
            class="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-500 rounded-lg bg-black/50 focus:ring-gray-500 focus:border-gray-500 ">
            <div class="flex">
              <div class="w-max">
                <div
                  class="font-family: Georgia typewriter overflow-hidden whitespace-nowrap text-sm md:text-2xl text-white">
                  <h1>Generate a video on volcanoes in California</h1></div>
              </div>
            </div>
          </div>

        </div>


      </div>

      <div class="py-12 relative  w-full h-200">
        <img class=" rounded-2xl shadow-2xl object-fit" rel="preload" src="/img/volcano.jpg" alt="Mount Shasta">
      
        </img>
        <div class="absolute bottom-50 px-4 py-3 w-full">
          <h1 class="text-white font-semibold sm:text-sm md:text-4xl text-center"> Mount Shasta is a volcano </h1>
          <h1 class="text-white font-semibold sm:text-sm md:text-4xl text-center"> located in Siskiyou County, California</h1>
        </div><a
          href="https://unsplash.com/@adrianvalverdem?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"></a><a
          href="https://unsplash.com/photos/kKmeMs_Qacs?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"></a>
      </div> 


      <div class="mx-auto flex-col justify-start items-center gap-12 inline-flex p-1">
        <div class="flex-col justify-start items-center gap-2 flex">
          <div class="font-family: Georgia text-center text-gray-300 text-sm md:text-4xl font-extrabold">Achieve your desired
            outcomes<br />through the power of Generative AI</div>
        </div>
        <div class="self-stretch  justify-start items-start gap-5 md:inline-flex sm:flex-col pb-[100px]">
          <div
            class="mb-8 grow bg-zinc-700 shadow-2xl shrink basis-0 h-80 px-7 py-12 rounded-lg  flex-col justify-start items-start gap-6 flex transition duration-500 hover:scale-105 hover:bg-blue-900">
            <div class="self-stretch h-32 flex-col justify-start items-start gap-2.5 flex">
              <div class="font-family: Georgia self-stretch text-sky-300 text-lg font-extrabold leading-7">EFFICIENCY
              </div>
              <div class="font-family: Georgia self-stretch  text-white text-opacity-70 text-lg font-normal leading-7">
                What percentage of your
                time goes into editing and desinging new content? Creating a script? With the combination of AI and our
                source content library we'll make that easy
                for you.</div>
            </div>
          </div>
          <div
            class="mb-8 grow bg-zinc-700 shadow-2xl shrink basis-0 h-80 px-7 py-12 rounded-lg  flex-col justify-start items-start gap-6 flex transition duration-500 hover:scale-105 hover:bg-blue-900">
            <div class="self-stretch h-32 flex-col justify-start items-start gap-2.5 flex">
              <div class="font-family: Georgia self-stretch text-sky-300 text-lg font-extrabold leading-7">CREATIVITY
              </div>
              <div class="font-family: Georgia self-stretch text-white text-opacity-70 text-lg font-normal leading-7">
                Create content like no
                other! Capture your audience with unique art and fully customizable avatars! Make yourself an avatar or
                choose your co-workers. We make training videos fun!</div>
            </div>
          </div>
          <div
            class="mb-8 grow bg-zinc-700 shadow-2xl shrink basis-0 h-80 px-7 py-12 rounded-lg  flex-col justify-start items-start gap-6 flex transition duration-500 hover:scale-105 hover:bg-blue-900">

            <div class="self-stretch h-24 flex-col justify-start items-start gap-2.5 flex">
              <div class="font-family: Georgia self-stretch text-sky-300 text-lg font-extrabold leading-7">ON DEMAND
              </div>
              <div class="font-family: Georgia self-stretch text-white text-opacity-70 text-lg font-normal leading-7">
                Literally one click away
                from content generation. No need to wait on turnaround. Once your prompt is submitted our service will
                take care of the rest.</div>
            </div>
          </div>
        </div>
      </div>






    </div>


    <!-- Grey box -->
    <div class="relative bg-slate-900/30 w-full">
      <div class="py-20 flex-col justify-start items-center gap-2 flex">
        <div class="font-family: Georgia text-center text-gray-300 text-4xl font-extrabold">How it Works</div>
      </div>


      <div class="container mx-auto w-full h-full ">
        <div class="relative wrap overflow-hidden sm:p-0 md:p-10 h-full ">
          <div class="border-2-2 absolute border-opacity-20 border-gray-700 h-full border left-1.5	md:inset-x-1/2"></div>
         
          <!-- right timeline 1-->
          <div class="mb-8 flex justify-between items-center w-full right-timeline">
            <div class="order-1 md:w-5/12"></div>
            <div class="z-0 flex items-center order-1 bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto font-semibold text-lg text-white">1</h1>
            </div>
            <!-- <div class="order-1 pl-6"></div> -->
            <div
              class="order-1  bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="gear" size="2xl"/> -->
              <h3 class="font-family: Georgia  mb-3 font-bold text-sky-300 text-2xl">Script</h3>
              <p class=" font-family: Georgia leading-snug tracking-wide text-white text-opacity-100 text-sm">Just
                input your prompt, choose the number of scenes, and specify the video length, and we'll effortlessly craft
                a script for you. 
              </p>
            </div>
          </div>
          

          <!-- left timeline 2 -->
          <div class="mb-8 flex justify-between md:flex-row-reverse items-center w-full sm:right-timeline md:left-timeline">
            <div class="md:w-5/12"></div>
            <div class="z-0 flex items-center  bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto text-white font-semibold text-lg">2</h1>
            </div>
            <!-- <div class="pl-0"></div> -->
            <div
            class=" bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="film" size="2xl" /> -->
              <h3 class="font-family: Georgia  mb-3 font-bold  text-sky-300 text-2xl">Illustration</h3>
              <p
                class="font-family: Georgia text-sm font-medium leading-snug tracking-wide text-white text-opacity-100">
                Leveraging cutting-edge AI technology, we craft diverse video scenes with ease. The context of these
                scenes is intelligently generated from your script's content. As AI continues to advance, our scenes will
                grow in richness and depth, allowing you to create personalized, engaging videos for your audience.
              </p>
            </div>
          </div>


                    <!-- right timeline -->
          <div class="mb-8 flex justify-between items-center w-full right-timeline">
            <div class="order-1 md:w-5/12"></div>
            <div class="z-0 flex items-center order-1 bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto font-semibold text-lg text-white">3</h1>
            </div>
            <!-- <div class="order-1 pl-6"></div> -->
            <div
              class="order-1  bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="gear" size="2xl"/> -->
              <h3 class="font-family: Georgia  mb-3 font-bold  text-sky-300 text-2xl">Narration</h3>
              <p class=" font-family: Georgia leading-snug tracking-wide text-white text-opacity-100 text-sm">
                Harnessing
                the forefront of text-to-speech technology, our videos feature expertly crafted narration to enhance your
                content. Moreover, you can opt for your own voice to be synthesized, adding a unique and personal
                dimension to your videos.
              </p>
            </div>
          </div>
          

          <!-- left timeline -->
          <div class="mb-8 flex justify-between md:flex-row-reverse items-center w-full sm:right-timeline md:left-timeline">
            <div class="md:w-5/12"></div>
            <div class="z-0 flex items-center  bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto text-white font-semibold text-lg">4</h1>
            </div>
            <!-- <div class="pl-0"></div> -->
            <div
            class=" bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="film" size="2xl" /> -->
              <h3 class="font-family: Georgia  mb-3 font-bold  text-sky-300 text-2xl">Animation</h3>
              <p
                class="font-family: Georgia text-sm font-medium leading-snug tracking-wide text-white text-opacity-100">
                We provide animations for all our generated art, including basic features like mouth movements and hand
                gestures. Furthermore, we have ambitious plans to incorporate more intricate and advanced animations in
                the near future.
              </p>
            </div>
          </div>

                    <!-- right timeline -->
                    <div class="mb-8 flex justify-between items-center w-full right-timeline">
            <div class="order-1 md:w-5/12"></div>
            <div class="z-0 flex items-center order-1 bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto font-semibold text-lg text-white">5</h1>
            </div>
            <!-- <div class="order-1 pl-6"></div> -->
            <div
              class="order-1  bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="gear" size="2xl"/> -->
              <h3 class="font-family: Georgia  mb-3 font-bold  text-sky-300 text-2xl">Sound & Music</h3>
              <p class=" font-family: Georgia leading-snug tracking-wide text-white text-opacity-100 text-sm">Select
                from our extensive library of music and sound effects to complement your video. Enjoy complete
                customization to align perfectly with the theme of your content, ensuring a seamless audio-visual
                experience.
              </p>
            </div>
          </div>
          

          <!-- left timeline -->
          <div class="mb-8 flex justify-between md:flex-row-reverse items-center w-full sm:right-timeline md:left-timeline">
            <div class="md:w-5/12"></div>
            <div class="z-0 flex items-center  bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto text-white font-semibold text-lg">6</h1>
            </div>
            <!-- <div class="pl-0"></div> -->
            <div
            class=" bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="film" size="2xl" /> -->
              <h3 class="font-family: Georgia  mb-3 font-bold  text-sky-300 text-2xl">Subtitles</h3>
              <p
                class="font-family: Georgia text-sm font-medium leading-snug tracking-wide text-white text-opacity-100">
                When activated, we'll automatically generate subtitles for your video, offering an additional layer of
                engagement. These subtitles are also exportable as standalone text files, allowing for versatile viewing
                and sharing options.
              </p>
            </div>
          </div>

                    <!-- right timeline -->
                    <div class="mb-8 flex justify-between items-center w-full right-timeline">
            <div class="order-1 md:w-5/12"></div>
            <div class="z-0 flex items-center order-1 bg-gray-800 shadow-xl w-8 md:w-8 md:h-8 rounded-full">
              <h1 class="mx-auto font-semibold text-lg text-white">7</h1>
            </div>
            <!-- <div class="order-1 pl-6"></div> -->
            <div
              class="order-1 bg-gray-800 rounded-lg shadow-2xl w-10/12 md:w-5/12 px-6 py-4 transition duration-500 hover:scale-105 hover:bg-green-800">
              <!-- <font-awesome-icon icon="gear" size="2xl"/> -->
              <h3 class="font-family: Georgia  mb-3 font-bold  text-sky-300 text-2xl">Fine Tuning</h3>
              <p class=" font-family: Georgia leading-snug tracking-wide text-white text-opacity-100 text-sm">Every
                segment of the video can be easily edited using straightforward functions. We're dedicated to empowering
                individuals without technical expertise, making video editing accessible and user-friendly for all.
              </p>
            </div>
          </div>
          



        </div>


      </div>
    </div>
  </div>
</template>

<style>
.backgroundSvg {
  background: linear-gradient(to bottom, white 5%, #5f9ea0);
  /* Gradient with heavier grey and less dominant pink */
}

.typewriter h1 {
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: .10em solid gray; /* The typwriter cursor */
  white-space: nowrap; /* Keeps the content on a single line */
  margin: 0 auto; /* Gives that scrolling effect as the typing happens */
  letter-spacing: .10em; /* Adjust as needed */
  animation: 
    typing 3.5s steps(40, end),
    blink-caret .75s step-end infinite;
}

/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: gray; }
}
</style>


<route lang="yaml">
  meta:
    layout: default
</route>
